import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../../../Features/storefrontSlice';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import LinkButton from '../../LinkButton/LinkButton';

function Bar() {
    return (
        <div className="flex items-center gap-[5px]">
            <div className="w-1/2 h-[1px] bg-[#D9D9D9]"></div>

            <p className='font-medium text-[12px] leading-3 text-[#6B7280]'>OR</p>

            <div className="w-1/2 h-[1px] bg-[#D9D9D9]"></div>
        </div>
    )
}

function Links({ errorText }) {
    const {
        singleBannerDesktop,
    } = useContext(StorefrontContext);

    const dispatch = useDispatch();

    function handleOpenCategoryModal() {
        dispatch(setModal('select-category'));
    }

    function handleOpenCategoryCollectionModal() {
        dispatch(setModal('select-category-collection'));
    }

    function handleOpenCustomCollectionModal() {
        dispatch(setModal('select-custom-collection'));
    }

    function handleOpenProductModal() {
        dispatch(setModal('select-product'));
    }

    return (
        <div className="flex flex-col gap-[5px]">
            <div className="flex items-center justify-between">
                <p className='font-medium text-[14px] leading-6 text-[#121212]'>Link to</p>

                <p className='text-[12px] leading-5 text-[#EF4444]'>{errorText}</p>
            </div>

            <LinkButton 
                handlerFunction={handleOpenCategoryModal} 
                title={Object.keys(singleBannerDesktop.category).length > 0 ? singleBannerDesktop.category.categoryName : 'category'} 
            />

            <Bar />

            <LinkButton 
                handlerFunction={handleOpenCategoryCollectionModal} 
                title={Object.keys(singleBannerDesktop.categoryCollection).length > 0 ? singleBannerDesktop.categoryCollection.CollectionName : 'collection'} 
            />

            <Bar />

            <LinkButton 
                handlerFunction={handleOpenCustomCollectionModal} 
                title={Object.keys(singleBannerDesktop.customCollection).length > 0 ? singleBannerDesktop.customCollection.CollectionName : 'custom collection'} 
            />

            <Bar />

            <LinkButton 
                handlerFunction={handleOpenProductModal} 
                title={singleBannerDesktop.product && Object.keys(singleBannerDesktop.product).length > 0 ? singleBannerDesktop.product.product.productName : 'product'} 
            />
        </div>
    );
}

export default Links;
